// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"f0f923c8","667":"86c69b01","907":"46e1b988"}[chunkId] + ".chunk.js";
};